import { Box, createStyles, Group, Stack, Table } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useApiListTeamsV2 } from '@repo/api-codegen/v2';
import { Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useWorkspace } from '../../api';
import { FullWidthLoadingSpinner } from '../../components/LoadingSpinner';
import { appShellStore } from '../../components/SecodaAppShell/store';
import { TeamRow } from './TeamRow';

const useStyles = createStyles((theme) => ({
	borderBottom: {
		borderBottom: `1px solid ${theme.other.getColor('border/secondary/default')}`,
	},
}));

function TeamsPage() {
	const { classes, theme } = useStyles();
	const { workspace } = useWorkspace();
	const isSmallScreen = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	const {
		navBarUI: {
			teamsPage: { includeArchive },
		},
	} = appShellStore;

	const { data: teams, isLoading } = useApiListTeamsV2({
		queryParams: {
			include_archived: includeArchive,
		},
	});

	if (!teams || isLoading) {
		return <FullWidthLoadingSpinner />;
	}

	return (
		<Stack px="xl" py="md">
			<Group position="center">
				<Table maw={864} w="100%">
					<thead className={classes.borderBottom}>
						<tr>
							<th>
								<Box pl={0} py={10}>
									<Text align="left" size="xs" color="text/secondary/default">
										Team name
									</Text>
								</Box>
							</th>
							{!isSmallScreen && (
								<th>
									<Box pl={0}>
										<Text align="left" size="xs" color="text/secondary/default">
											Member
										</Text>
									</Box>
								</th>
							)}
							{workspace?.migrated_permission_v2 ? null : (
								<th>
									<Box pl={0}>
										<Text align="left" size="xs" color="text/secondary/default">
											Role
										</Text>
									</Box>
								</th>
							)}
							<th>
								<Box pl={0} />
							</th>
						</tr>
					</thead>
					<tbody>
						{teams.map((team) => (
							<TeamRow
								key={team.id}
								team={team}
								isSmallScreen={isSmallScreen}
							/>
						))}
					</tbody>
				</Table>
			</Group>
		</Stack>
	);
}

const TeamsPageWithObserver = observer(TeamsPage);
export default TeamsPageWithObserver;
